import React from "react";
import { useTranslation } from "react-i18next";

function AboutUs() {
  const { t } = useTranslation("about");

  return (
    <>
      <style jsx>{`
        .feature-card {
          transition: all 0.3s ease;
          cursor: pointer;
        }
        
        .feature-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(73, 69, 56, 0.2) !important;
          border-color: rgb(73, 69, 56) !important;
        }
        
        .feature-icon {
          transition: all 0.3s ease;
        }
        
        .feature-card:hover .feature-icon {
          transform: scale(1.1);
          background-color: rgba(73, 69, 56, 0.2) !important;
        }
        
        .value-card {
          transition: all 0.3s ease;
          cursor: pointer;
        }
        
        .value-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.1) !important;
          border-color: rgb(73, 69, 56) !important;
        }
        
        @media (max-width: 768px) {
          .feature-card {
            padding: 30px 15px;
            margin-bottom: 20px;
          }
          
          .feature-icon {
            width: 50px !important;
            height: 50px !important;
          }
          
          .hero-title {
            font-size: 2.5rem !important;
          }
          
          .hero-subtitle {
            font-size: 1.1rem !important;
          }
          
          .stats-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 20px !important;
          }
          
          .about-image img {
            height: 300px !important;
          }
          
          .about-content h2 {
            font-size: 2rem !important;
          }
          
          .about-text {
            font-size: 1rem !important;
          }
          
          .stat-number {
            font-size: 2rem !important;
          }
          
          .stat-label {
            font-size: 0.8rem !important;
          }
        }
        
        @media (max-width: 480px) {
          .feature-card {
            padding: 25px 15px;
            margin-bottom: 15px;
          }
          
          .feature-icon {
            width: 45px !important;
            height: 45px !important;
          }
          
          .hero-title {
            font-size: 2rem !important;
            line-height: 1.1 !important;
          }
          
          .hero-subtitle {
            font-size: 1rem !important;
            margin-bottom: 40px !important;
          }
          
          .stats-grid {
            grid-template-columns: 1fr !important;
            gap: 20px !important;
          }
          
          .about-content h2 {
            font-size: 1.8rem !important;
            margin-bottom: 15px !important;
          }
          
          .about-text {
            font-size: 0.95rem !important;
            margin-bottom: 30px !important;
          }
          
          .stat-number {
            font-size: 1.8rem !important;
          }
          
          .stat-label {
            font-size: 0.75rem !important;
          }
          
          .about-image img {
            height: 250px !important;
          }
          
          .section {
            padding: 60px 0 !important;
          }
        }
      `}</style>
      
      <section className="tc-about-style1 section" style={{ 
        backgroundColor: '#ffffff', 
        padding: '100px 0',
        marginTop: '60px'
      }}>
      <div className="container">
        {/* Hero Section */}
        {/* <div className="row mb-5">
          <div className="col-12 text-center">
            <h1 className="hero-title" style={{
              fontSize: '3rem',
              fontWeight: '700',
              color: '#333',
              marginBottom: '20px',
              fontFamily: 'Montserrat, sans-serif',
              lineHeight: '1.2'
            }}>
              {t("hero.title")}
            </h1>
            <p className="hero-subtitle" style={{
              fontSize: '1.2rem',
              color: '#666',
              maxWidth: '800px',
              margin: '0 auto 60px',
              lineHeight: '1.6'
            }}>
              {t("hero.subtitle")}
            </p>
          </div>
        </div> */}

        {/* Feature Cards */}
        <div className="row mb-5">
          <div className="col-lg-3 col-md-6 mb-4">
            <div className="feature-card" style={{
              textAlign: 'center',
              padding: '40px 20px',
              backgroundColor: '#ffffff',
              borderRadius: '15px',
              border: '1px solid rgba(73, 69, 56, 0.2)',
              boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
              height: '100%'
            }}>
              <div className="feature-icon" style={{
                width: '60px',
                height: '60px',
                backgroundColor: 'rgba(73, 69, 56, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                color: 'rgb(73, 69, 56)'
              }}>
                <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: '30px', height: '30px' }}>
                  <path d="M12 2L15.09 8.26L22 9L17 14L18.18 21L12 17.77L5.82 21L7 14L2 9L8.91 8.26L12 2Z" fill="currentColor"/>
                </svg>
              </div>
              <h4 style={{
                fontSize: '1.2rem',
                fontWeight: '600',
                color: '#333',
                marginBottom: '15px',
                fontFamily: 'Montserrat, sans-serif'
              }}>{t("features.experienced.title")}</h4>
              <p style={{
                fontSize: '0.9rem',
                color: '#666',
                lineHeight: '1.5'
              }}>{t("features.experienced.description")}</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 mb-4">
            <div className="feature-card" style={{
              textAlign: 'center',
              padding: '40px 20px',
              backgroundColor: '#ffffff',
              borderRadius: '15px',
              border: '1px solid rgba(73, 69, 56, 0.2)',
              boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
              height: '100%'
            }}>
              <div className="feature-icon" style={{
                width: '60px',
                height: '60px',
                backgroundColor: 'rgba(73, 69, 56, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                color: 'rgb(73, 69, 56)'
              }}>
                <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: '30px', height: '30px' }}>
                  <path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                  <circle cx="8.5" cy="7" r="4" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                  <path d="M20 8V14M23 11H17" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                  <circle cx="20" cy="11" r="2" fill="currentColor"/>
                </svg>
              </div>
              <h4 style={{
                fontSize: '1.2rem',
                fontWeight: '600',
                color: '#333',
                marginBottom: '15px',
                fontFamily: 'Montserrat, sans-serif'
              }}>{t("features.pricing.title")}</h4>
              <p style={{
                fontSize: '0.9rem',
                color: '#666',
                lineHeight: '1.5'
              }}>{t("features.pricing.description")}</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 mb-4">
            <div className="feature-card" style={{
              textAlign: 'center',
              padding: '40px 20px',
              backgroundColor: '#ffffff',
              borderRadius: '15px',
              border: '1px solid rgba(73, 69, 56, 0.2)',
              boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
              height: '100%'
            }}>
              <div className="feature-icon" style={{
                width: '60px',
                height: '60px',
                backgroundColor: 'rgba(73, 69, 56, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                color: 'rgb(73, 69, 56)'
              }}>
                <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: '30px', height: '30px' }}>
                  <path d="M3 21H21L19 19H5L3 21ZM5 19H19V7H5V19ZM7 9H17V11H7V9ZM7 13H17V15H7V13ZM7 5H17V7H7V5Z" fill="currentColor"/>
                </svg>
              </div>
              <h4 style={{
                fontSize: '1.2rem',
                fontWeight: '600',
                color: '#333',
                marginBottom: '15px',
                fontFamily: 'Montserrat, sans-serif'
              }}>{t("features.timeliness.title")}</h4>
              <p style={{
                fontSize: '0.9rem',
                color: '#666',
                lineHeight: '1.5'
              }}>{t("features.timeliness.description")}</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 mb-4">
            <div className="feature-card" style={{
              textAlign: 'center',
              padding: '40px 20px',
              backgroundColor: '#ffffff',
              borderRadius: '15px',
              border: '1px solid rgba(73, 69, 56, 0.2)',
              boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
              height: '100%'
            }}>
              <div className="feature-icon" style={{
                width: '60px',
                height: '60px',
                backgroundColor: 'rgba(73, 69, 56, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                color: 'rgb(73, 69, 56)'
              }}>
                <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: '30px', height: '30px' }}>
                  <path d="M12 2L13.09 8.26L20 9L14 14L15.18 21L12 17.77L8.82 21L10 14L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
                  <path d="M9 12L11 14L15 10" stroke="white" strokeWidth="2" fill="none"/>
                </svg>
              </div>
              <h4 style={{
                fontSize: '1.2rem',
                fontWeight: '600',
                color: '#333',
                marginBottom: '15px',
                fontFamily: 'Montserrat, sans-serif'
              }}>{t("features.materials.title")}</h4>
              <p style={{
                fontSize: '0.9rem',
                color: '#666',
                lineHeight: '1.5'
              }}>{t("features.materials.description")}</p>
            </div>
          </div>
        </div>

        {/* Company Overview */}
        <div className="row align-items-center mb-5">
          <div className="col-lg-6">
            <div className="about-image" style={{
              position: 'relative',
              borderRadius: '15px',
              overflow: 'hidden',
              boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
            }}>
              <img
                src="/home1/assets/img/slider/3.jpg"
                alt="OneArt Construction"
                style={{
                  width: '100%',
                  height: '400px',
                  objectFit: 'cover'
                }}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-content">
              <h2 style={{
                fontSize: '2.5rem',
                fontWeight: '600',
                color: '#333',
                marginBottom: '20px',
                fontFamily: 'Montserrat, sans-serif'
              }}>
                {t("overview.title")}
              </h2>
              <div className="about-text" style={{
                fontSize: '1.1rem',
                color: '#666',
                lineHeight: '1.8',
                marginBottom: '40px'
              }}>
                {t("overview.description")}
              </div>
              <div className="stats-grid" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '30px',
                marginTop: '40px'
              }}>
                <div className="stat-item" style={{ textAlign: 'center' }}>
                  <div className="stat-number" style={{
                    fontSize: '2.5rem',
                    fontWeight: '700',
                    color: 'rgb(73, 69, 56)',
                    fontFamily: 'Montserrat, sans-serif',
                    marginBottom: '10px'
                  }}>50+</div>
                  <div className="stat-label" style={{
                    fontSize: '0.9rem',
                    color: '#666',
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                  }}>{t("stats.projects")}</div>
                </div>
                <div className="stat-item" style={{ textAlign: 'center' }}>
                  <div className="stat-number" style={{
                    fontSize: '2.5rem',
                    fontWeight: '700',
                    color: 'rgb(73, 69, 56)',
                    fontFamily: 'Montserrat, sans-serif',
                    marginBottom: '10px'
                  }}>20+</div>
                  <div className="stat-label" style={{
                    fontSize: '0.9rem',
                    color: '#666',
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                  }}>{t("stats.years")}</div>
                </div>
                <div className="stat-item" style={{ textAlign: 'center' }}>
                  <div className="stat-number" style={{
                    fontSize: '2.5rem',
                    fontWeight: '700',
                    color: 'rgb(73, 69, 56)',
                    fontFamily: 'Montserrat, sans-serif',
                    marginBottom: '10px'
                  }}>12</div>
                  <div className="stat-label" style={{
                    fontSize: '0.9rem',
                    color: '#666',
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                  }}>{t("stats.ongoing")}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mission & Vision */}
       

        
      </div>

      {/* Awards Section */}
      <section className="awards-section" style={{
        padding: '120px 0',
        backgroundColor: '#ffffff'
      }}>
        <div className="container">
          <div className="text-center mb-80">
            <h2 style={{
              fontSize: '3rem',
              fontWeight: '700',
              color: '#333',
              marginBottom: '20px'
            }}>
              {t('awards.title')}
            </h2>
            <p style={{
              fontSize: '1.2rem',
              color: '#666',
              maxWidth: '700px',
              margin: '0 auto'
            }}>
              {t('awards.subtitle')}
            </p>
          </div>

          <div className="row g-5">
            <div className="col-lg-4 col-md-6">
              <div className="award-card" style={{
                position: 'relative',
                height: '650px',
                borderRadius: '28px',
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 25px 60px rgba(0,0,0,0.15)'
              }}
              onClick={() => window.location.href = '/innerpages/portfolio'}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-18px)';
                e.currentTarget.style.boxShadow = '0 35px 70px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 25px 60px rgba(0,0,0,0.15)';
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: 'url(/projects/BelleMare/IMG_7365.JPG)',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat'
                }}></div>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(135deg, rgba(0,0,0,0.7), rgba(0,0,0,0.4))'
                }}></div>
                
                {/* Award Star */}
                <div style={{
                  position: 'absolute',
                  top: '30px',
                  right: '30px',
                  width: '45px',
                  height: '45px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  borderRadius: '50%',
                  boxShadow: '0 0 20px rgba(255, 215, 0, 0.8), 0 4px 15px rgba(0,0,0,0.3)',
                  zIndex: 2,
                  animation: 'pulse 2s infinite'
                }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="#FFD700">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                </div>
                
                <div style={{
                  position: 'absolute',
                  bottom: '0',
                  left: '0',
                  right: '0',
                  padding: '50px 40px 40px',
                  color: 'white'
                }}>
                  <div style={{
                    fontSize: '1.1rem',
                    fontWeight: '700',
                    color: 'rgb(73, 69, 56)',
                    marginBottom: '15px',
                    textTransform: 'uppercase',
                    letterSpacing: '2px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.buildingOfYear.category')}
                  </div>
                  <h3 style={{
                    fontSize: '2.2rem',
                    fontWeight: '800',
                    marginBottom: '15px',
                    lineHeight: '1.2',
                    textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.buildingOfYear.title')}
                  </h3>
                  <p style={{
                    fontSize: '1.2rem',
                    opacity: '0.98',
                    margin: 0,
                    lineHeight: '1.6',
                    textShadow: '0 1px 2px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.buildingOfYear.description')}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="award-card" style={{
                position: 'relative',
                height: '650px',
                borderRadius: '28px',
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 25px 60px rgba(0,0,0,0.15)'
              }}
              onClick={() => window.location.href = '/innerpages/portfolio'}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-18px)';
                e.currentTarget.style.boxShadow = '0 35px 70px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 25px 60px rgba(0,0,0,0.15)';
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: 'url(/home1/assets/img/slider/IMG_0578.jpeg)',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat'
                }}></div>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(135deg, rgba(0,0,0,0.7), rgba(0,0,0,0.4))'
                }}></div>
                
                {/* Award Star */}
                <div style={{
                  position: 'absolute',
                  top: '30px',
                  right: '30px',
                  width: '45px',
                  height: '45px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  borderRadius: '50%',
                  boxShadow: '0 0 20px rgba(255, 215, 0, 0.8), 0 4px 15px rgba(0,0,0,0.3)',
                  zIndex: 2,
                  animation: 'pulse 2s infinite'
                }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="#FFD700">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                </div>
                
                <div style={{
                  position: 'absolute',
                  bottom: '0',
                  left: '0',
                  right: '0',
                  padding: '50px 40px 40px',
                  color: 'white'
                }}>
                  <div style={{
                    fontSize: '1.1rem',
                    fontWeight: '700',
                    color: 'rgb(73, 69, 56)',
                    marginBottom: '15px',
                    textTransform: 'uppercase',
                    letterSpacing: '2px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.fifthElement.category')}
                  </div>
                  <h3 style={{
                    fontSize: '2.2rem',
                    fontWeight: '800',
                    marginBottom: '15px',
                    lineHeight: '1.2',
                    textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.fifthElement.title')}
                  </h3>
                  <p style={{
                    fontSize: '1.2rem',
                    opacity: '0.98',
                    margin: 0,
                    lineHeight: '1.6',
                    textShadow: '0 1px 2px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.fifthElement.description')}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="award-card" style={{
                position: 'relative',
                height: '650px',
                borderRadius: '28px',
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 25px 60px rgba(0,0,0,0.15)'
              }}
              onClick={() => window.location.href = '/innerpages/portfolio'}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-18px)';
                e.currentTarget.style.boxShadow = '0 35px 70px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 25px 60px rgba(0,0,0,0.15)';
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: 'url(/home1/assets/img/slider/head_slide1.jpg)',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat'
                }}></div>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(135deg, rgba(0,0,0,0.7), rgba(0,0,0,0.4))'
                }}></div>
                
                <div style={{
                  position: 'absolute',
                  bottom: '0',
                  left: '0',
                  right: '0',
                  padding: '50px 40px 40px',
                  color: 'white'
                }}>
                  <div style={{
                    fontSize: '1.1rem',
                    fontWeight: '700',
                    color: 'rgb(73, 69, 56)',
                    marginBottom: '15px',
                    textTransform: 'uppercase',
                    letterSpacing: '2px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.bigSeaArchitecture.category')}
                  </div>
                  <h3 style={{
                    fontSize: '2.2rem',
                    fontWeight: '800',
                    marginBottom: '15px',
                    lineHeight: '1.2',
                    textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.bigSeaArchitecture.title')}
                  </h3>
                  <p style={{
                    fontSize: '1.2rem',
                    opacity: '0.98',
                    margin: 0,
                    lineHeight: '1.6',
                    textShadow: '0 1px 2px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.bigSeaArchitecture.description')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* CSS Animation for Star Pulse */}
      <style>{`
        @keyframes pulse {
          0% {
            box-shadow: 0 0 20px rgba(255, 215, 0, 0.6), 0 4px 15px rgba(0,0,0,0.3);
          }
          50% {
            box-shadow: 0 0 30px rgba(255, 215, 0, 0.8), 0 4px 20px rgba(0,0,0,0.4);
          }
          100% {
            box-shadow: 0 0 20px rgba(255, 215, 0, 0.6), 0 4px 15px rgba(0,0,0,0.3);
          }
        }
      `}</style>
    </section>
    </>
  );
}

export default AboutUs;
